window.getCurrentBreakpoint = function () {

	if (window.matchMedia('(min-width: 1500px)').matches) {
		return 'xxl';
	} else if (window.matchMedia('(min-width: 1200px)').matches) {
		return 'xl';
	} else if (window.matchMedia('(min-width: 992px)').matches) {
		return 'lg';
	} else if (window.matchMedia('(min-width: 768px)').matches) {
		return 'md';
	} else if (window.matchMedia('(min-width: 576px)').matches) {
		return 'sm';
	} else {
		return 'xs';
	}

}
